module.exports = __webpack_public_path__ + "94f6bd2712edacbacae40ea8f0416a0c.pdf";